export default "__VITE_ASSET__cbe935b1__"